import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { SuiSpinner } from '@splashthat/sui';
import { DEFAULT_INPUT_LABEL_COLOR } from 'common/entities/form/styleConfiguration/defaultValues';
import { getFormQuestionLabelColor } from 'common/entities/form/styleConfiguration/selectors';
import { getFormRendererFormId } from '../../../../selectors';

const LoaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const LoaderLabel = styled.div`
    margin-top: 1rem;
    color: ${(props) => props.color};
`;

const Loader = ({ label, color }) => (
    <LoaderContainer>
        <SuiSpinner size="small" delay={false} color={color} />
        <LoaderLabel color={color}>{label}</LoaderLabel>
    </LoaderContainer>
);

Loader.propTypes = {
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
    const formId = getFormRendererFormId(state);
    const questionLabelColor = getFormQuestionLabelColor(state, formId);
    return {
        color: questionLabelColor || DEFAULT_INPUT_LABEL_COLOR,
    };
};

export default connect(mapStateToProps, undefined)(Loader);
